import {
    NonRegularDriverPropsInterface,
    PurchasedProductUnion,
} from '@app/core/interfaces';
import { PolicyProductInterface } from '@app/core/interfaces';
import { type } from '@app/store/util';
import { Action } from '@ngrx/store';
import { Notification } from 'outshared-lib';

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const CLEAR = type('[my-zone container] clear product store');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const ADD_NOTIFICATIONS = type('[product effects] add notifications');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const CLEAR_NOTIFICATIONS = type('[my-zone component] clear notifications');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const LOAD_POLICY = type('[my-zone component] Load policy');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const LOAD_POLICY_SUCCESS = type('[product effects] Load policy Success');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const LOAD_PURCHASED_PRODUCT = type('[product effect] Load Product Detail');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const LOAD_PURCHASED_PRODUCT_SUCCESS = type('[product effect] Load Product Detail Success');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const CANCEL_FUTURE_PURCHASED_PRODUCT = type('[my-zone component] cancel future purchased product');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const CANCEL_FUTURE_PURCHASED_PRODUCT_SUCCESS = type('[product effect] cancel future purchased product success');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const TERMINATE_ACTIVE_PURCHASED_PRODUCT = type('[my-zone component] terminate active purchased product');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const TERMINATE_ACTIVE_PURCHASED_PRODUCT_SUCCESS = type('[product effect] terminate active purchased product success');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const MODIFY_FUTURE_PURCHASED_PRODUCT_START_DATE = type('[my-zone component] modify future purchased product start date');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const MODIFY_FUTURE_PURCHASED_PRODUCT_START_DATE_SUCCESS =
    type('[product effect] modify future purchased product start date success');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const MODIFY_TERMINATION_DATE_FOR_PRODUCT_END_DATE = type('[my-zone component] modify new termination date for future purchased product end date');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const MODIFY_TERMINATION_DATE_FOR_PRODUCT_END_DATE_SUCCESS =
    type('[product effect] modify new termination date for future purchased product end date success');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const REVIVE_TERMINATED_PURCHASED_PRODUCT = type('[my-zone component] revive terminated purchased product');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const REVIVE_TERMINATED_PURCHASED_PRODUCT_SUCCESS = type('[product effect] revive terminated purchased product success');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const STORE_NON_REGULAR_DRIVER = type('[my-zone component] store non regular driver');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const STORE_NON_REGULAR_DRIVER_SUCCESS = type('[product effect] store non regular driver success');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const TERMINATE_ACTIVE_NON_REGULAR_DRIVER = type('[my-zone component] remove driver');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const TERMINATE_ACTIVE_NON_REGULAR_DRIVER_SUCCESS = type('[product effect] remove driver success');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const CANCEL_FUTURE_NON_REGULAR_DRIVER = type('[my-zone component] cancel driver');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const CANCEL_FUTURE_NON_REGULAR_DRIVER_SUCCESS = type('[product effect] cancel driver success');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const CANCEL_FUTURE_NON_REGULAR_DRIVER_OWNER = type('[product effect] cancel future non regular driver owner');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const CANCEL_FUTURE_NON_REGULAR_DRIVER_OWNER_SUCCESS = type('[product effect] cancel future non regular driver owner success');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const DISPLAY_PREMIUM_IMPACT = type('[premium] display premium impact');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const UPDATE_PREMIUM_DETERMINING_FACTOR_SUCCESS = type('[my-zone component] update premium determining factor success');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const CANCEL_FUTURE_MODIFIABLE_PREMIUM_DETERMINING_FACTOR = type('[my-zone component] cancel future modifiable premium determining factor');
/** @deprecated use outshared-lib - InsurancePolicyActionService */
export const CANCEL_FUTURE_MODIFIABLE_PREMIUM_DETERMINING_FACTOR_SUCCESS = type('[product effect] cancel future modifiable premium determining factor success');

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class Clear implements Action {
    readonly type = CLEAR;
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class AddNotifications implements Action {
    readonly type = ADD_NOTIFICATIONS;
    constructor(public payload: { notifications: Notification[] }) {}
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class ClearNotifications implements Action {
    readonly type = CLEAR_NOTIFICATIONS;
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class LoadPolicy implements Action {
    readonly type = LOAD_POLICY;
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class LoadPolicySuccess implements Action {
    readonly type = LOAD_POLICY_SUCCESS;
    constructor(public payload: PolicyProductInterface[]) {}
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class LoadPurchasedProduct implements Action {
    readonly type = LOAD_PURCHASED_PRODUCT;
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class LoadPurchasedProductSuccess implements Action {
    readonly type = LOAD_PURCHASED_PRODUCT_SUCCESS;
    constructor(public payload: PurchasedProductUnion) {}
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class CancelFuturePurchasedProduct implements Action {
    readonly type = CANCEL_FUTURE_PURCHASED_PRODUCT;
    constructor(public payload: { purchased_product_sequence_number: number }) {}
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class CancelFuturePurchasedProductSuccess implements Action {
    readonly type = CANCEL_FUTURE_PURCHASED_PRODUCT_SUCCESS;
    constructor(public payload: { purchased_product_sequence_number: number }) {}
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class TerminateActivePurchasedProduct implements Action {
    readonly type = TERMINATE_ACTIVE_PURCHASED_PRODUCT;
    constructor(public payload: { purchased_product_sequence_number: number, end_date: string }) {}
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class TerminateActivePurchasedProductSuccess implements Action {
    readonly type = TERMINATE_ACTIVE_PURCHASED_PRODUCT_SUCCESS;
    constructor(public payload: { purchased_product_sequence_number: number, end_date: string }) {}
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class ReviveTerminatedPurchasedProduct implements Action {
    readonly type = REVIVE_TERMINATED_PURCHASED_PRODUCT;
    constructor(public payload: { purchased_product_sequence_number: number }) {}
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class ReviveTerminatedPurchasedProductSuccess implements Action {
    readonly type = REVIVE_TERMINATED_PURCHASED_PRODUCT_SUCCESS;
    constructor(public payload: { purchased_product_sequence_number: number }) {}
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class ModifyFuturePurchasedProductStartDate implements Action {
    readonly type = MODIFY_FUTURE_PURCHASED_PRODUCT_START_DATE;
    constructor(public payload: { purchased_product_sequence_number: number, start_date: string }) {}
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class ModifyFuturePurchasedProductStartDateSuccess implements Action {
    readonly type = MODIFY_FUTURE_PURCHASED_PRODUCT_START_DATE_SUCCESS;
    constructor(public payload: { purchased_product_sequence_number: number, start_date: string }) {}
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class ModifyTerminationDateForProductEndDate implements Action {
    readonly type = MODIFY_TERMINATION_DATE_FOR_PRODUCT_END_DATE;
    constructor(public payload: { purchased_product_sequence_number: number, end_date: string }) {}
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class ModifyTerminationDateForProductEndDateSuccess implements Action {
    readonly type = MODIFY_TERMINATION_DATE_FOR_PRODUCT_END_DATE_SUCCESS;
    constructor(public payload: { purchased_product_sequence_number: number, end_date: string }) {}
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class StoreNonRegularDriver implements Action {
    readonly type = STORE_NON_REGULAR_DRIVER;
    constructor(public payload: {
        purchased_product_sequence_number: number, non_regular_driver: NonRegularDriverPropsInterface }) {}
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class StoreNonRegularDriverSuccess implements Action {
    readonly type = STORE_NON_REGULAR_DRIVER_SUCCESS;
    constructor(public payload: {
        purchased_product_sequence_number: number, non_regular_driver: NonRegularDriverPropsInterface }) {}
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class TerminateActiveNonRegularDriver implements Action {
    readonly type = TERMINATE_ACTIVE_NON_REGULAR_DRIVER;
    constructor(public payload: { purchased_product_sequence_number: number, end_date: string }) {}
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class TerminateActiveNonRegularDriverSuccess implements Action {
    readonly type = TERMINATE_ACTIVE_NON_REGULAR_DRIVER_SUCCESS;
    constructor(public payload: { purchased_product_sequence_number: number, end_date: string }) {}
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class CancelFutureNonRegularDriver implements Action {
    readonly type = CANCEL_FUTURE_NON_REGULAR_DRIVER;
    constructor(public payload: { purchased_product_sequence_number: number }) {}
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class CancelFutureNonRegularDriverSuccess implements Action {
    readonly type = CANCEL_FUTURE_NON_REGULAR_DRIVER_SUCCESS;
    constructor(public payload: { purchased_product_sequence_number: number }) {}
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class CancelFutureNonRegularDriverOwner implements Action {
    readonly type = CANCEL_FUTURE_NON_REGULAR_DRIVER_OWNER;
    constructor(public payload: { purchased_product_sequence_number: number }) {}
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class CancelFutureNonRegularDriverOwnerSuccess implements Action {
    readonly type = CANCEL_FUTURE_NON_REGULAR_DRIVER_OWNER_SUCCESS;
    constructor(public payload: { purchased_product_sequence_number: number }) {}
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class DisplayPremiumImpact implements Action {
    readonly type = DISPLAY_PREMIUM_IMPACT;
    constructor(public payload: { reference_date: string, purchased_product_sequence_number?: number }) {}
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class UpdatePremiumDeterminingFactorSuccess implements Action {
    readonly type = UPDATE_PREMIUM_DETERMINING_FACTOR_SUCCESS;
    constructor(public payload: {
        purchased_product_sequence_number: number;
        premium_determining_factor_id: string;
        premium_determining_factor_value_description: string;
        start_date: string;
    }) {}
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class CancelFutureModifiablePremiumDeterminingFactor implements Action {
    readonly type = CANCEL_FUTURE_MODIFIABLE_PREMIUM_DETERMINING_FACTOR;
    constructor(public payload: { purchased_product_sequence_number: number, premium_determining_factor_id: string }) {}
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export class CancelFutureModifiablePremiumDeterminingFactorSuccess implements Action {
    readonly type = CANCEL_FUTURE_MODIFIABLE_PREMIUM_DETERMINING_FACTOR_SUCCESS;
    constructor(public payload: { purchased_product_sequence_number: number, premium_determining_factor_id: string }) {}
}

/** @deprecated use outshared-lib - InsurancePolicyActionService */
export type ProductsActions
    = Clear
    | AddNotifications
    | ClearNotifications
    | LoadPolicy
    | LoadPolicySuccess
    | LoadPurchasedProduct
    | LoadPurchasedProductSuccess
    | CancelFuturePurchasedProduct
    | CancelFuturePurchasedProductSuccess
    | TerminateActivePurchasedProduct
    | TerminateActivePurchasedProductSuccess
    | ReviveTerminatedPurchasedProduct
    | ReviveTerminatedPurchasedProductSuccess
    | ModifyFuturePurchasedProductStartDate
    | ModifyFuturePurchasedProductStartDateSuccess
    | ModifyTerminationDateForProductEndDate
    | ModifyTerminationDateForProductEndDateSuccess
    | StoreNonRegularDriver
    | StoreNonRegularDriverSuccess
    | TerminateActiveNonRegularDriver
    | TerminateActiveNonRegularDriverSuccess
    | CancelFutureNonRegularDriver
    | CancelFutureNonRegularDriver
    | CancelFutureNonRegularDriverSuccess
    | CancelFutureNonRegularDriverOwnerSuccess
    | DisplayPremiumImpact
    | UpdatePremiumDeterminingFactorSuccess
    | CancelFutureModifiablePremiumDeterminingFactor
    | CancelFutureModifiablePremiumDeterminingFactorSuccess;
